var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSeguranca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10579 3.00438C2.62804 2.45671 3.17582 53.4001 8.10579 53.4C13.0358 53.3999 50.8325 32.5843 50.8325 28.2022C50.8325 23.82 13.5835 3.55206 8.10579 3.00438Z",
    fill: "#E9EFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5C31.5533 22.5 32.8125 21.2408 32.8125 19.6875C32.8125 18.1342 31.5533 16.875 30 16.875C28.4467 16.875 27.1875 18.1342 27.1875 19.6875C27.1875 21.2408 28.4467 22.5 30 22.5Z",
    stroke: "url(#paint0_linear_5_128)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5V25.875",
    stroke: "url(#paint1_linear_5_128)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 12.375H18.75C18.1287 12.375 17.625 12.8787 17.625 13.5V29.25C17.625 29.8713 18.1287 30.375 18.75 30.375H41.25C41.8713 30.375 42.375 29.8713 42.375 29.25V13.5C42.375 12.8787 41.8713 12.375 41.25 12.375Z",
    stroke: "url(#paint2_linear_5_128)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9375 12.375V7.3125C24.9375 5.96984 25.4709 4.68217 26.4203 3.73277C27.3697 2.78337 28.6573 2.25 30 2.25C31.3427 2.25 32.6303 2.78337 33.5797 3.73277C34.5291 4.68217 35.0625 5.96984 35.0625 7.3125V12.375",
    stroke: "url(#paint3_linear_5_128)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_128",
    x1: 27.1875,
    y1: 19.6875,
    x2: 32.8125,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_128",
    x1: 30,
    y1: 24.1875,
    x2: 31,
    y2: 24.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_128",
    x1: 17.625,
    y1: 21.375,
    x2: 42.375,
    y2: 21.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_128",
    x1: 24.9375,
    y1: 7.3125,
    x2: 35.0625,
    y2: 7.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeguranca);
export default __webpack_public_path__ + "static/media/icon-seguranca.c0b2ca0be85361994c0d980ee137a34a.svg";
export { ForwardRef as ReactComponent };